export class StockChartConfiguartion {
}

import { StockChartConfig } from '../../stock-chart-module/stock-chart/stock-chart/stock-chart-model';
import { ProjConstants } from 'src/app/utils/proj.constant';



export const RainfallMIS: StockChartConfig = {
  chartId: 'RainfallMIS',
  kickStartRequired: ['filter'],
  chartOptions: {
    navigator: true,
    indicators: false,
    secondaryChart: false,
    labels: false,
    connectNulls: true,
    hideDataGaps: true,
    rangeSelector: false,
    scrollbar: false,
    yAxis: {
      labelsAlignment: 'left',
      unitAsTitle: false,
      unitsBesideLabel: false,
      labelsFormatter: {
        functionName: 'formatNumber',
      }
    },
  },
  filterConfig: [
    {
      type: 'dropdown',
      config: {
        title: 'Time Interval',
        key: 'timeInterval',
        type: 'manual',
        icon: 'assets/stockChart/interval.svg',
        byDefaultSelect: 'yyyyMMdd',
        options: [
          {
            title: '1 Day',
            key: 'yyyyMMdd',
          },
          {
            title: '1 Month',
            key: 'yyyyMM',
          },
          {
            title: '1 Year',
            key: 'yyyy'
          },
        ]
      },
      changeFireEventType: 'api',
      functionsFireOnChange: 'all'
    }
  ],
  applicationConfig: {
    normal: {
      id: 'normal',
      title: 'Normal Rainfall',
      chartType: 'spline',
      additionalPostParams: 'all',
      unit: 'mm',
      rendererConfig: {
        chartType: 'spline',
        chartColor: '#FFB900',
        renderer: 'primary',
        visible: true
      },
      apiConfig: {
        apiId: 'rainfall',
        apiKeyName: 'RAINFALL_CHART_API',
        method: 'post',
        titleField: 'normal',
        keyField: 'objectKey',
        //   urlString: 'KWRIS_API',
        postData: {
          cType: 'STATION',
          aggr: 'SUM',
          component: 'rainfall',
          chartType: 'stock',
          summary: false,
          pEUUID: ProjConstants.STATETOUUIDMAPPING['ANDHRA PRADESH'],
        },
        postDataFormatter: {
          functionName: 'kwrisFormatter',
          formatter: (data) => {
            console.log('data in the Kwris Formatter', data);
            return data;
          }
        },
        dataFormatter: {
          functionName: 'dataFormatterForActual',
          formatter: (data) => {
            return data;
          }
        },
      }
    },
    greaterNormal: {
      id: 'greaterNormal',
      title: '> Normal',
      chartType: 'column',
      additionalPostParams: 'all',
      unit: 'mm',
      apiConfig: {
        apiId: 'rainfall',
        apiKeyName: 'RAINFALL_CHART_API',
        method: 'post',
        titleField: 'greaterNormal',
        keyField: 'objectKey',
        postData: {
          cType: 'STATION',
          aggr: 'SUM',
          component: 'rainfall',
          chartType: 'stock',
          summary: false,
          pEUUID: ProjConstants.STATETOUUIDMAPPING['ANDHRA PRADESH'],
        },
        postDataFormatter: {
          functionName: 'kwrisFormatter',
          formatter: (data) => {
            console.log('data in the Kwris Formatter', data);
            return data;
          }
        }
      },
      rendererConfig: {
        chartType: 'column',
        chartColor: '#2D99FF',
        renderer: 'primary',
        visible: true,
      },
    },

    lessNormal: {
      id: 'lessNormal',
      title: '< Normal',
      chartType: 'column',
      additionalPostParams: 'all',
      unit: 'mm',
      apiConfig: {
        apiId: 'rainfall',
        apiKeyName: 'RAINFALL_CHART_API',
        method: 'post',
        titleField: 'lessNormal',
        keyField: 'objectKey',
        postData: {
          cType: 'STATION',
          aggr: 'SUM',
          component: 'rainfall',
          chartType: 'stock',
          summary: false,
          pEUUID: ProjConstants.STATETOUUIDMAPPING['ANDHRA PRADESH'],
        },
        postDataFormatter: {
          functionName: 'kwrisFormatter',
          formatter: (data) => {
            console.log('data in the Kwris Formatter', data);
            return data;
          }
        }
      },
      rendererConfig: {
        chartType: 'column',
        chartColor: '#FF6C40',
        renderer: 'primary',
        visible: true
      }
    },
  },
  applicationAdditionalParams: {
    filter: {
      timeInterval: 'format',
    },
  },
  routerConfig: {
    routeChangeInvoke: false,
    paramMap: {
      pType: 'lType',
      locUUID: 'lUUID',
      src: 'src',
      sDate: 'sDate',
      eDate: 'eDate',
      view: 'view'
    }
  },
};

export const RAINFALLGIS: StockChartConfig = {
  chartId: 'RAINFALLGIS',
  kickStartRequired: [],
  chartOptions: {
    navigator: true,
    indicators: false,
    secondaryChart: false,
    labels: false,
    connectNulls: true,
    hideDataGaps: true,
    rangeSelector: false,
    scrollbar: false,
    yAxis: {
      labelsAlignment: 'left',
      unitAsTitle: false,
      unitsBesideLabel: false,
      labelsFormatter: {
        functionName: 'formatNumber',
      }
    }
  },
  filterConfig: [
  ],
  applicationConfig: {
    normal: {
      id: 'normal',
      title: 'Normal Rainfall',
      chartType: 'spline',
      additionalPostParams: 'all',
      unit: 'mm',
      rendererConfig: {
        chartType: 'spline',
        chartColor: '#FFB900',
        renderer: 'primary',
        visible: true
      },
      apiConfig: {
        apiId: 'rainfall',
        apiKeyName: 'RAINFALL_CHART_API',
        method: 'post',
        titleField: 'normal',
        keyField: 'objectKey',
        //   urlString: 'KWRIS_API',
        postData: {
          cType: 'STATION',
          aggr: 'SUM',
          component: 'rainfall',
          chartType: 'stock',
          summary: false,
          // pEUUID: ProjConstants.STATETOUUIDMAPPING['ANDHRA PRADESH'],
        },
        dataFormatter: {
          functionName: 'dataFormatterForActual',
          formatter: (data) => {
            return data;
          }
        },
      }
    },
    greaterNormal: {
      id: 'greaterNormal',
      title: '> Normal',
      chartType: 'column',
      additionalPostParams: 'all',
      unit: 'mm',
      apiConfig: {
        apiId: 'rainfall',
        apiKeyName: 'RAINFALL_CHART_API',
        method: 'post',
        titleField: 'greaterNormal',
        keyField: 'objectKey',
        postData: {
          cType: 'STATION',
          aggr: 'SUM',
          component: 'rainfall',
          chartType: 'stock',
          summary: false,
          // pEUUID: ProjConstants.STATETOUUIDMAPPING['ANDHRA PRADESH'] ,
        },
      },
      rendererConfig: {
        chartType: 'column',
        chartColor: '#2D99FF',
        renderer: 'primary',
        visible: true
      }
    },
    lessNormal: {
      id: 'lessNormal',
      title: '< Normal',
      chartType: 'column',
      additionalPostParams: 'all',
      unit: 'mm',
      apiConfig: {
        apiId: 'rainfall',
        apiKeyName: 'RAINFALL_CHART_API',
        method: 'post',
        titleField: 'lessNormal',
        keyField: 'objectKey',
        postData: {
          cType: 'STATION',
          aggr: 'SUM',
          component: 'rainfall',
          chartType: 'stock',
          summary: false,
          // pEUUID: ProjConstants.STATETOUUIDMAPPING['ANDHRA PRADESH'] ,
        },
      },
      rendererConfig: {
        chartType: 'column',
        chartColor: '#FF6C40',
        renderer: 'primary',
        visible: true
      }
    },
  },
  applicationAdditionalParams: {
  },
  routerConfig: {
    routeChangeInvoke: true,
    paramMap: {
      loctype: 'lType',
      locuuid: 'lUUID',
      src: 'src',
      sDate: 'sDate',
      eDate: 'eDate',
      format: 'format',
      view: 'view',
      pEUUID: 'pEUUID'
    }
  },
}

export const BottomBarData: StockChartConfig = {
  chartId: 'BottomBarData',
  kickStartRequired: [],
  chartOptions: {
    navigator: true,
    indicators: false,
    secondaryChart: false,
    labels: false,
    connectNulls: true,
    hideDataGaps: true,
    rangeSelector: false,
    scrollbar: false,
    yAxis: {
      labelsAlignment: 'left',
      unitAsTitle: false,
      unitsBesideLabel: false,
      labelsFormatter: {
        functionName: 'formatNumber',
      }
    }
  },
  filterConfig: [
  ],
  applicationConfig: {
    actual: {
      id: 'normal',
      title: 'Normal Rainfall',
      chartType: 'spline',
      additionalPostParams: 'all',
      unit: 'mm',
      rendererConfig: {
        chartType: 'spline',
        chartColor: '#FFB900',
        renderer: 'primary',
        visible: true
      },
      apiConfig: {
        apiId: 'rainfall',
        apiKeyName: 'RAINFALL_BOTTOMBAR_API',
        method: 'post',
        titleField: 'normal',
        keyField: 'objectKey',
        //   urlString: 'KWRIS_API',
        postData: {
          component: 'rainfall',
          chartType: 'stock',
          summary: false,
          sUUID: ProjConstants.STATETOUUIDMAPPING['ANDHRA PRADESH'],
        },
        dataFormatter: {
          functionName: 'dataFormatterForActual',
          formatter: (data) => {
            return data;
          }
        },
      }
    },
    greaterNormal: {
      id: 'greaterNormal',
      title: '> Normal',
      chartType: 'column',
      additionalPostParams: 'all',
      unit: 'mm',
      apiConfig: {
        apiId: 'rainfall',
        apiKeyName: 'RAINFALL_CHART_API',
        method: 'post',
        titleField: 'greaterNormal',
        keyField: 'objectKey',
        postData: {
          component: 'rainfall',
          chartType: 'stock',
          summary: false,
          sUUID: ProjConstants.STATETOUUIDMAPPING['ANDHRA PRADESH'],
        },
      },
      rendererConfig: {
        chartType: 'column',
        chartColor: '#2D99FF',
        renderer: 'primary',
        visible: true
      }
    },
    lessNormal: {
      id: 'lessNormal',
      title: '< Normal',
      chartType: 'column',
      additionalPostParams: 'all',
      unit: 'mm',
      apiConfig: {
        apiId: 'rainfall',
        apiKeyName: 'RAINFALL_CHART_API',
        method: 'post',
        titleField: 'lessNormal',
        keyField: 'objectKey',
        postData: {
          component: 'rainfall',
          chartType: 'stock',
          summary: false,
          sUUID: ProjConstants.STATETOUUIDMAPPING['ANDHRA PRADESH'],
        },
      },
      rendererConfig: {
        chartType: 'column',
        chartColor: '#FF6C40',
        renderer: 'primary',
        visible: true
      }
    },
  },
  applicationAdditionalParams: {
  },
  routerConfig: {
    routeChangeInvoke: true,
    paramMap: {
      src: 'src',
      sDate: 'sDate',
      eDate: 'eDate',
      format: 'format',
      view: 'view'
    }
  },
}

export const WINDSPEEDGIS: StockChartConfig = {
  chartId: 'WindspeedGIS',
  kickStartRequired: [],
  chartOptions: {
    navigator: true,
    indicators: false,
    secondaryChart: false,
    labels: false,
    connectNulls: true,
    hideDataGaps: true,
    rangeSelector: false,
    scrollbar: false,
    yAxis: {
      labelsAlignment: 'left',
      unitAsTitle: false,
      unitsBesideLabel: false,
      labelsFormatter: {
        functionName: 'formatNumber',
      }
    }
  },
  filterConfig: [
  ],
  applicationConfig: {
    windspeed: {
      id: 'windspeed',
      title: 'Windspeed',
      chartType: 'spline',
      additionalPostParams: 'all',
      unit: ' kmph',
      apiConfig: {
        // apiCompareConfig: {
        //   compareKey: 'NMAX',
        //   compareType: ['greater'],
        //   greaterColor: '#FF6C40'
        // },
        candleStickConfig: {
          highField: 'maxWS',
          lowField: 'minWS',
          openField: 'maxWS',
          closeField: 'minWS',
        },
        // areaRangeConfig: {
        //   areaMin: 'NMIN',
        //   areaMax: 'NMAX'
        // },
        apiId: 'windspeed',
        apiKeyName: 'WINDSPEED_CHART_API',
        method: 'post',
        titleField: 'maxWS',
        keyField: 'objectKey',
        //   urlString: 'KWRIS_API',
        postData: {
          aggr: 'SUM',
          cType: 'STATION',
          chartType: 'stock',
          component: 'wind',
          // pEUUID:ProjConstants.STATETOUUIDMAPPING['ANDHRA PRADESH']
        },
        postDataFormatter: {
          functionName: 'kwrisFormatter',
          formatter: (data) => {
            console.log('data in the Kwris Formatter', data);
            return data;
          }
        }
      },
      rendererConfig: {
        renderer: 'primary',
        visible: true,
        chartType: ['candlestick'],
        chartColor: ['#2D99FF']
      },
      serviceConfig: {
        unit: {
          functionName: 'formatUnits',
          additionalServiceParams: 'all'
        }
      }
    }
  },
  applicationAdditionalParams: {
    // filter: {
    //   timeInterval: 'format',
    // },
    // date: {
    //     startDate: 'startDateText',
    //     endDate: 'endDateText',
    // },
    // componentSubscription: {
    //     sample : 'sample'
    // }
  },
  routerConfig: {
    routeChangeInvoke: true,
    paramMap: {
      loctype: 'lType',
      locuuid: 'lUUID',
      src: 'src',
      format: 'format',
      sDate: 'sDate',
      eDate: 'eDate',
      pEUUID: 'pEUUID'
    }
    // paramMap: {
    //     id : 'waterId'
    // }
  },
};

export const BOTTOMBARWINDSPEED: StockChartConfig = {
  chartId: 'BottomBarWindSpeed',
  kickStartRequired: [],
  chartOptions: {
    navigator: true,
    indicators: false,
    secondaryChart: false,
    labels: false,
    connectNulls: true,
    hideDataGaps: true,
    rangeSelector: false,
    scrollbar: false,
    yAxis: {
      labelsAlignment: 'left',
      unitAsTitle: false,
      unitsBesideLabel: false,
      labelsFormatter: {
        functionName: 'formatNumber',
      }
    }
  },
  filterConfig: [
  ],
  applicationConfig: {
    actual: {
      id: 'windspeed',
      title: 'Windspeed',
      chartType: 'spline',
      additionalPostParams: 'all',
      unit: ' kmph',
      apiConfig: {
        // apiCompareConfig: {
        //   compareKey: 'NMAX',
        //   compareType: ['greater'],
        //   greaterColor: '#FF6C40'
        // },
        candleStickConfig: {
          highField: 'maxWS',
          lowField: 'minWS',
          openField: 'maxWS',
          closeField: 'minWS',
        },
        // areaRangeConfig: {
        //   areaMin: 'NMIN',
        //   areaMax: 'NMAX'
        // },
        apiId: 'windspeed',
        apiKeyName: 'WINDSPEED_BOTTOMBAR_API',
        method: 'post',
        titleField: 'maxWS',
        keyField: 'objectKey',
        //   urlString: 'KWRIS_API',
        postData: {
          summary: false,
          chartType: 'stock',
          component: 'wind',
          // sUUID: ProjConstants.STATETOUUIDMAPPING['ANDHRA PRADESH']
        },
        postDataFormatter: {
          functionName: 'kwrisFormatter',
          formatter: (data) => {
            console.log('data in the Kwris Formatter', data);
            return data;
          }
        }
      },
      rendererConfig: {
        renderer: 'primary',
        visible: true,
        chartType: ['candlestick'],
        chartColor: ['#2D99FF']
      },
      serviceConfig: {
        unit: {
          functionName: 'formatUnits',
          additionalServiceParams: 'all'
        }
      }
    }
  },
  applicationAdditionalParams: {
    // filter: {
    //   timeInterval: 'format',
    // },
    // date: {
    //     startDate: 'startDateText',
    //     endDate: 'endDateText',
    // },
    // componentSubscription: {
    //     sample : 'sample'
    // }
  },
  routerConfig: {
    routeChangeInvoke: true,
    paramMap: {
      src: 'src',
      sDate: 'sDate',
      eDate: 'eDate',
      format: 'format',
      view: 'view',
      sUUID: 'sUUID'
    }
    // paramMap: {
    //     id : 'waterId'
    // }
  },
};

// from kwris
export const TemperatureGISNEW: StockChartConfig = {
  chartId: 'TemperatureGISNEW',
  kickStartRequired: [],
  chartOptions: {
    navigator: true,
    indicators: false,
    secondaryChart: false,
    labels: false,
    connectNulls: true,
    hideDataGaps: true,
    rangeSelector: false,
    scrollbar: false,
    yAxis: {
      labelsAlignment: 'left',
      unitAsTitle: false,
      unitsBesideLabel: false,
      labelsFormatter: {
        functionName: 'formatNumber',
      }
    }
  },
  filterConfig: [
  ],
  applicationConfig: {
    temperature: {
      id: 'temperature',
      title: 'Temperature',
      chartType: 'spline',
      additionalPostParams: 'all',
      unit: '&#8451',
      apiConfig: {
        apiCompareConfig: {
          compareKey: 'NMAX',  // normal max
          compareType: ['greater'],
          greaterColor: '#FF6C40'
        },
        candleStickConfig: {
          highField: 'MAX',  // Actual max
          lowField: 'MIN',   // actual min
          openField: 'MAX',  // Actual max
          closeField: 'MIN', // actual min
        },
        areaRangeConfig: {
          areaMin: 'NMIN',  // normal min
          areaMax: 'NMAX'  // normal max
        },
        apiId: 'temperature',
        apiKeyName: 'TEMPERATURE_CHART_API',
        method: 'post',
        titleField: 'MAX',
        keyField: 'objectKey',
        //   urlString: 'KWRIS_API',
        postData: {
          component: 'temperature',
          classification: ['ACTUAL', 'NORMAL'],
        },
        postDataFormatter: {
          functionName: 'kwrisFormatter',
          formatter: (data) => {
            console.log('data in the Kwris Formatter', data);
            return data;
          }
        },
        dataFormatter: {
          functionName: 'formatterForTemperatureChart',
          formatter: (data) => {
            return data;
          }
        }
      },
      rendererConfig: {
        renderer: 'primary',
        visible: true,
        chartType: ['candlestick', 'areasplinerange'],
        chartColor: ['#2D99FF', '#FF8F6D']
      },
      serviceConfig: {
        unit: {
          functionName: 'formatUnits',
          additionalServiceParams: 'all'
        }
      }
    }
  },
  applicationAdditionalParams: {
    // filter: {
    //   timeInterval: 'format',
    // },
    // date: {
    //     startDate: 'startDateText',
    //     endDate: 'endDateText',
    // },
    // componentSubscription: {
    //     sample : 'sample'
    // }
  },
  routerConfig: {
    routeChangeInvoke: true,
    paramMap: {
      // loctype:'lType',
      // locuuid:'pUUID',
      src: 'src',
      format: 'format',
      sDate: 'sDate',
      eDate: 'eDate',
      // cType:'cType',
      pEUUID: 'pEUUID',
      pUUID: 'pUUID',
      pType: 'pType',
      // classfication: "classfication"
    }
    // paramMap: {
    //     id : 'waterId'
    // }
  },
};

// from kwris
export const BOTTOMBARTEMPERATURE: StockChartConfig = {
  chartId: 'BottombarChartTemperature',
  kickStartRequired: [],
  chartOptions: {
    navigator: true,
    indicators: false,
    secondaryChart: false,
    labels: false,
    connectNulls: true,
    hideDataGaps: true,
    rangeSelector: false,
    scrollbar: false,
    yAxis: {
      labelsAlignment: 'left',
      unitAsTitle: false,
      unitsBesideLabel: false,
      labelsFormatter: {
        functionName: 'formatNumber',
      }
    }
  },
  filterConfig: [
  ],
  applicationConfig: {
    actual: {
      id: 'temperature',
      title: 'Temperature',
      chartType: 'spline',
      additionalPostParams: 'all',
      unit: '&#8451',
      apiConfig: {
        apiCompareConfig: {
          compareKey: 'NMAX',  // normal max
          compareType: ['greater'],
          greaterColor: '#FF6C40'
        },
        candleStickConfig: {
          highField: 'MAX',  // Actual max
          lowField: 'MIN',   // actual min
          openField: 'MAX',  // Actual max
          closeField: 'MIN', // actual min
        },
        areaRangeConfig: {
          areaMin: 'NMIN',  // normal min
          areaMax: 'NMAX'  // normal max
        },
        apiId: 'temperature',
        apiKeyName: 'TEMPERATURE_BOTTOMBAR_API',
        method: 'post',
        titleField: 'MAX',
        keyField: 'objectKey',
        //   urlString: 'KWRIS_API',
        postData: {
          component: 'temperature',
          classification: ['ACTUAL', 'NORMAL'],
        },
        postDataFormatter: {
          functionName: 'kwrisFormatter',
          formatter: (data) => {
            console.log('data in the Kwris Formatter', data);
            return data;
          }
        },
        dataFormatter: {
          functionName: 'formatterForTemperatureChart',
          formatter: (data) => {
            return data;
          }
        }
      },
      rendererConfig: {
        renderer: 'primary',
        visible: true,
        chartType: ['candlestick', 'areasplinerange'],
        chartColor: ['#2D99FF', '#FF8F6D']
      },
      serviceConfig: {
        unit: {
          functionName: 'formatUnits',
          additionalServiceParams: 'all'
        }
      }
    }
  },
  applicationAdditionalParams: {
    // filter: {
    //   timeInterval: 'format',
    // },
    // date: {
    //     startDate: 'startDateText',
    //     endDate: 'endDateText',
    // },
    // componentSubscription: {
    //     sample : 'sample'
    // }
  },
  routerConfig: {
    routeChangeInvoke: true,
    paramMap: {
      // loctype:'lType',
      // locuuid:'pUUID',
      src: 'src',
      format: 'format',
      sDate: 'sDate',
      eDate: 'eDate',
      // cType:'cType',
      pEUUID: 'pEUUID',
      pUUID: 'pUUID',
      pType: 'pType',
      // classfication: "classfication"
    }
    // paramMap: {
    //     id : 'waterId'
    // }
  },
};

// from kwris
export const HumidityMIS: StockChartConfig = {
  chartId: 'HumidityMISNEW',
  kickStartRequired: [],
  chartOptions: {
    navigator: true,
    indicators: false,
    secondaryChart: false,
    labels: false,
    connectNulls: true,
    hideDataGaps: true,
    rangeSelector: false,
    scrollbar: false,
    yAxis: {
      labelsAlignment: 'left',
      unitAsTitle: false,
      unitsBesideLabel: false,
      labelsFormatter: {
        functionName: 'formatNumber',
      }
    }
  },
  filterConfig: [
  ],
  applicationConfig: {
    humidity: {
      id: 'humidity',
      title: 'Humidity',
      chartType: 'spline',
      additionalPostParams: 'all',
      unit: ' %',
      apiConfig: {
        // apiCompareConfig: {
        //   compareKey: 'NMAX',
        //   compareType: ['greater'],
        //   greaterColor: '#FF6C40'
        // },
        candleStickConfig: {
          highField: 'MAX',
          lowField: 'MIN',
          openField: 'MAX',
          closeField: 'MIN',
        },
        // areaRangeConfig: {
        //   areaMin: 'NMIN',
        //   areaMax: 'NMAX'
        // },
        apiId: 'humidity',
        apiKeyName: 'HUMIDITY_CHART_API',
        method: 'post',
        titleField: 'MAX',
        keyField: 'objectKey',
        //   urlString: 'KWRIS_API',
        postData: {
          // component: 'humidity',
          classification: ['ACTUAL']
        },
        postDataFormatter: {
          functionName: 'kwrisFormatter',
          formatter: (data) => {
            console.log('data in the Kwris Formatter', data);
            return data;
          }
        },
        dataFormatter: {
          functionName: 'formatterForHumidityChart',
          formatter: (data) => {
            return data;
          }
        }
      },
      rendererConfig: {
        renderer: 'primary',
        visible: true,
        chartType: ['candlestick'],
        chartColor: ['#2D99FF']
        // 2CD9C5
      },
      serviceConfig: {
        unit: {
          functionName: 'formatUnits',
          additionalServiceParams: 'all'
        }
      }
    }
  },

  applicationAdditionalParams: {
    // filter: {
    //   timeInterval: 'format',
    // },
    // date: {
    //     startDate: 'startDateText',
    //     endDate: 'endDateText',
    // },
    // componentSubscription: {
    //     sample : 'sample'
    // }
  },
  routerConfig: {
    routeChangeInvoke: false,
    paramMap: {
      // loctype:'lType',
      // locuuid:'pUUID',
      src: 'src',
      format: 'format',
      sDate: 'sDate',
      eDate: 'eDate',
      // cType:'cType',
      pEUUID: 'pEUUID',
      pUUID: 'pUUID',
      pType: 'pType',
      // classfication: "classfication"
    }
    // paramMap: {
    //     id : 'waterId'
    // }
  },
}

// from kwris
export const BOTTOMBARHUMIDITY: StockChartConfig = {
  chartId: 'BottombarChartHumidity',
  kickStartRequired: [],
  chartOptions: {
    navigator: true,
    indicators: false,
    secondaryChart: false,
    labels: false,
    connectNulls: true,
    hideDataGaps: true,
    rangeSelector: false,
    scrollbar: false,
    yAxis: {
      labelsAlignment: 'left',
      unitAsTitle: false,
      unitsBesideLabel: false,
      labelsFormatter: {
        functionName: 'formatNumber',
      }
    }
  },
  filterConfig: [
  ],
  applicationConfig: {
    actual: {
      id: 'humidity',
      title: 'Humidity',
      chartType: 'spline',
      additionalPostParams: 'all',
      unit: ' %',
      apiConfig: {
        // apiCompareConfig: {
        //   compareKey: 'NMAX',
        //   compareType: ['greater'],
        //   greaterColor: '#FF6C40'
        // },
        candleStickConfig: {
          highField: 'MAX',
          lowField: 'MIN',
          openField: 'MAX',
          closeField: 'MIN',
        },
        // areaRangeConfig: {
        //   areaMin: 'NMIN',
        //   areaMax: 'NMAX'
        // },
        apiId: 'humidity',
        apiKeyName: 'HUMIDITY_BOTTOMBAR_API',
        method: 'post',
        titleField: 'MAX',
        keyField: 'objectKey',
        //   urlString: 'KWRIS_API',
        postData: {
          // component: 'humidity',
          classification: ['ACTUAL']
        },
        postDataFormatter: {
          functionName: 'kwrisFormatter',
          formatter: (data) => {
            console.log('data in the Kwris Formatter', data);
            return data;
          }
        },
        dataFormatter: {
          functionName: 'formatterForHumidityChart',
          formatter: (data) => {
            return data;
          }
        }
      },
      rendererConfig: {
        renderer: 'primary',
        visible: true,
        chartType: ['candlestick'],
        chartColor: ['#2D99FF']
        // 2CD9C5
      },
      serviceConfig: {
        unit: {
          functionName: 'formatUnits',
          additionalServiceParams: 'all'
        }
      }
    }
  },

  applicationAdditionalParams: {
    // filter: {
    //   timeInterval: 'format',
    // },
    // date: {
    //     startDate: 'startDateText',
    //     endDate: 'endDateText',
    // },
    // componentSubscription: {
    //     sample : 'sample'
    // }
  },
  routerConfig: {
    routeChangeInvoke: false,
    paramMap: {
      // loctype:'lType',
      // locuuid:'pUUID',
      src: 'src',
      format: 'format',
      sDate: 'sDate',
      eDate: 'eDate',
      // cType:'cType',
      pEUUID: 'pEUUID',
      pUUID: 'pUUID',
      pType: 'pType',
      // classfication: "classfication"
    }
    // paramMap: {
    //     id : 'waterId'
    // }
  },
}

// To be removed
export const TemperatureMIS: StockChartConfig = {
  chartId: 'TemperatureMIS',
  kickStartRequired: ['filter'],
  chartOptions: {
    navigator: true,
    indicators: false,
    secondaryChart: false,
    labels: false,
    connectNulls: true,
    hideDataGaps: true,
    rangeSelector: false,
    scrollbar: false,
    yAxis: {
      labelsAlignment: 'left',
      unitAsTitle: false,
      unitsBesideLabel: false,
      labelsFormatter: {
        functionName: 'formatNumber',
      }
    }
  },
  filterConfig: [
    {
      type: 'dropdown',
      config: {
        title: 'Time Interval',
        key: 'timeInterval',
        type: 'manual',
        icon: 'assets/stockChart/interval.svg',
        byDefaultSelect: 'yyyyMMdd',
        options: [
          {
            title: '1 Day',
            key: 'yyyyMMdd',
          },
          {
            title: '1 Month',
            key: 'yyyyMM',
          },
          // {
          //   title: '1 Year',
          //   key: 'yyyy'
          // },
        ]
      },
      changeFireEventType: 'api',
      functionsFireOnChange: 'all'
    }
  ],
  applicationConfig: {
    min: {
      id: 'normal',
      title: 'Min',
      chartType: 'column',
      additionalPostParams: 'all',
      unit: ' °C',
      rendererConfig: {
        chartType: 'column',
        chartColor: '#21C46B',
        renderer: 'primary',
        visible: true
      },
      apiConfig: {
        apiId: 'temperature',
        apiKeyName: 'TEMPERATURE_CHART_API',
        method: 'post',
        titleField: 'MIN',
        keyField: 'objectKey',
        //   urlString: 'KWRIS_API',
        postData: {
          component: 'temperature',
          pEUUID: ProjConstants.STATETOUUIDMAPPING['ANDHRA PRADESH']
        },
        postDataFormatter: {
          functionName: 'kwrisFormatter',
          formatter: (data) => {
            console.log('data in the Kwris Formatter', data);
            return data;
          }
        }
      }
    },
    max: {
      id: 'normal',
      title: 'Max',
      chartType: 'column',
      additionalPostParams: 'all',
      unit: ' °C',
      rendererConfig: {
        chartType: 'column',
        chartColor: '#25A1CB',
        renderer: 'primary',
        visible: true
      },
      apiConfig: {
        apiId: 'temperature',
        apiKeyName: 'TEMPERATURE_CHART_API',
        method: 'post',
        titleField: 'MAX',
        keyField: 'objectKey',
        //   urlString: 'KWRIS_API',
        postData: {
          component: 'temperature',
          pEUUID: ProjConstants.STATETOUUIDMAPPING['ANDHRA PRADESH']
        },
        postDataFormatter: {
          functionName: 'kwrisFormatter',
          formatter: (data) => {
            console.log('data in the Kwris Formatter', data);
            return data;
          }
        }
      }
    },
    mean: {
      id: 'normal',
      title: 'Mean',
      chartType: 'column',
      additionalPostParams: 'all',
      unit: ' °C',
      rendererConfig: {
        chartType: 'column',
        chartColor: '#FEBA4C',
        renderer: 'primary',
        visible: true
      },
      apiConfig: {
        apiId: 'temperature',
        apiKeyName: 'TEMPERATURE_CHART_API',
        method: 'post',
        titleField: 'AVG',
        keyField: 'objectKey',
        //   urlString: 'KWRIS_API',
        postData: {
          component: 'temperature',
          pEUUID: ProjConstants.STATETOUUIDMAPPING['ANDHRA PRADESH']
        },
        postDataFormatter: {
          functionName: 'kwrisFormatter',
          formatter: (data) => {
            console.log('data in the Kwris Formatter', data);
            return data;
          }
        }
      }
    },

  },
  applicationAdditionalParams: {
    filter: {
      timeInterval: 'format',
    },
    // date: {
    //     startDate: 'startDateText',
    //     endDate: 'endDateText',
    // },
    // componentSubscription: {
    //     sample : 'sample'
    // }
  },
  routerConfig: {
    routeChangeInvoke: false,
    paramMap: {
      pType: 'lType',
      locUUID: 'pUUID',
      src: 'src',
      startDateForWaterYear: 'sDate',
      sDate: 'eDate',
      cType: 'cType'
    }
    // paramMap: {
    //     id : 'waterId'
    // }
  },
};

export const TemperatureGIS: StockChartConfig = {
  chartId: 'TemperatureGIS',
  kickStartRequired: [],
  chartOptions: {
    navigator: true,
    indicators: false,
    secondaryChart: false,
    labels: false,
    connectNulls: true,
    hideDataGaps: true,
    rangeSelector: false,
    scrollbar: false,
    yAxis: {
      labelsAlignment: 'left',
      unitAsTitle: false,
      unitsBesideLabel: false,
      labelsFormatter: {
        functionName: 'formatNumber',
      }
    }
  },
  filterConfig: [
  ],
  applicationConfig: {
    min: {
      id: 'normal',
      title: 'Min',
      chartType: 'column',
      additionalPostParams: 'all',
      unit: ' °C',
      rendererConfig: {
        chartType: 'column',
        chartColor: '#21C46B',
        renderer: 'primary',
        visible: true
      },
      apiConfig: {
        apiId: 'temperature',
        apiKeyName: 'TEMPERATURE_CHART_API',
        method: 'post',
        titleField: 'MIN',
        keyField: 'objectKey',
        //   urlString: 'KWRIS_API',
        postData: {
          component: 'temperature',
          pEUUID: ProjConstants.STATETOUUIDMAPPING['ANDHRA PRADESH'],
        },
        postDataFormatter: {
          // functionName: 'kwrisFormatter',
          // formatter: (data) => {
          //   console.log('data in the Kwris Formatter', data);
          //   return data;
          // }
        }
      }
    },
    max: {
      id: 'normal',
      title: 'Max',
      chartType: 'column',
      additionalPostParams: 'all',
      unit: ' °C',
      rendererConfig: {
        chartType: 'column',
        chartColor: '#25A1CB',
        renderer: 'primary',
        visible: true
      },
      apiConfig: {
        apiId: 'temperature',
        apiKeyName: 'TEMPERATURE_CHART_API',
        method: 'post',
        titleField: 'MAX',
        keyField: 'objectKey',
        //   urlString: 'KWRIS_API',
        postData: {
          component: 'temperature',
          pEUUID: ProjConstants.STATETOUUIDMAPPING['ANDHRA PRADESH'],
        },
        postDataFormatter: {
          // functionName: 'kwrisFormatter',
          // formatter: (data) => {
          //   console.log('data in the Kwris Formatter', data);
          //   return data;
          // }
        }
      }
    },
    mean: {
      id: 'normal',
      title: 'Mean',
      chartType: 'column',
      additionalPostParams: 'all',
      unit: ' °C',
      rendererConfig: {
        chartType: 'column',
        chartColor: '#FEBA4C',
        renderer: 'primary',
        visible: true
      },
      apiConfig: {
        apiId: 'temperature',
        apiKeyName: 'TEMPERATURE_CHART_API',
        method: 'post',
        titleField: 'AVG',
        keyField: 'objectKey',
        //   urlString: 'KWRIS_API',
        postData: {
          component: 'temperature',
          pEUUID: ProjConstants.STATETOUUIDMAPPING['ANDHRA PRADESH'],
        },
        postDataFormatter: {
          // functionName: 'kwrisFormatter',
          // formatter: (data) => {
          //   console.log('data in the Kwris Formatter', data);
          //   return data;
          // }
        }
      }
    },

  },
  applicationAdditionalParams: {
    // filter: {
    //   timeInterval: 'format',
    // },
    // date: {
    //     startDate: 'startDateText',
    //     endDate: 'endDateText',
    // },
    // componentSubscription: {
    //     sample : 'sample'
    // }
  },
  routerConfig: {
    routeChangeInvoke: true,
    paramMap: {
      loctype: 'lType',
      locuuid: 'pUUID',
      src: 'src',
      format: 'format',
      sDate: 'sDate',
      eDate: 'eDate',
      cType: 'cType'
    }
    // paramMap: {
    //     id : 'waterId'
    // }
  },
};

export const ReservoirMIS: StockChartConfig = {
  chartId: 'ReservoirMIS',
  kickStartRequired: [],
  chartOptions: {
    navigator: true,
    indicators: false,
    secondaryChart: false,
    labels: false,
    connectNulls: true,
    hideDataGaps: true,
    rangeSelector: false,
    scrollbar: false,
    yAxis: {
      labelsAlignment: 'left',
      unitAsTitle: false,
      unitsBesideLabel: false,
      labelsFormatter: {
        functionName: 'formatNumber',
      }
    }
  },
  filterConfig: [
    // {
    //   type: 'dropdown',
    //   config: {
    //     title: 'Time Interval',
    //     key: 'timeInterval',
    //     type: 'manual',
    //     icon: 'assets/stockChart/interval.svg',
    //     byDefaultSelect: 'yyyyMMdd',
    //     options: [
    //       {
    //         title: '1 Day',
    //         key: 'yyyyMMdd',
    //       },
    //       {
    //         title: '1 Month',
    //         key: 'yyyyMM',
    //       },
    //       {
    //         title: '1 Year',
    //         key: 'yyyy'
    //       },
    //     ]
    //   },
    //   changeFireEventType: 'api',
    //   functionsFireOnChange: 'all'
    // }
  ],
  applicationConfig: {

    liveStorage: {
      id: 'liveStorage',
      title: 'Live Storage',
      chartType: 'areaspline',
      additionalPostParams: 'all',
      unit: 'MCM',
      rendererConfig: {
        chartType: 'areaspline',
        chartColor: '#3e9cee',
        renderer: 'primary',
        visible: true,
      },
      apiConfig: {
        apiId: 'reservoir',
        apiKeyName: 'RESERVOIR_CHART_API',
        method: 'post',
        titleField: 'MonYear.latestStorage',
        keyField: 'objectKey',
        //   urlString: 'KWRIS_API',
        postData: {
          component: 'reservoir',
          chartType: 'stock',
          pEUUID: ProjConstants.STATETOUUIDMAPPING['ANDHRA PRADESH'],
          format: 'yyyyMMdd'
        },
        postDataFormatter: {
          // functionName: 'kwrisFormatter',
          // formatter: (data) => {
          //   console.log('data in the Kwris Formatter', data);
          //   return data;
          // }
        }
      }
    },

    //       liveStorage2: {
    //           id: 'liveStorage2',
    //           title: 'Last Year Live Storage',
    //           chartType: 'line',
    //           additionalPostParams: 'all',
    //           unit: 'MCM',
    //           apiConfig: {
    //               apiKeyName: 'RESERVOIR_STOCK_CHART',
    //               method: 'get',
    //               titleField: 'PrevMonYear.latestStorage',
    //               keyField: 'objectKey',
    //               postData: {
    //                   component: "reservoir",
    //                 //   view:"admin",
    //                   chartType:"stock",
    //                   pEUUID:ProjConstants.STATETOUUIDMAPPING['ANDHRA PRADESH'],
    //                   format:"yyyyMMdd"
    //               }
    //           }
    //       },

    liveStorage2: {
      id: 'liveStorage2',
      title: 'Last Year Live Storage',
      chartType: 'line',
      additionalPostParams: 'all',
      unit: 'MCM',
      rendererConfig: {
        chartType: 'line',
        chartColor: '#FF7043',
        renderer: 'primary',
        visible: true,
        onLoadVisible: false
      },
      apiConfig: {
        apiId: 'reservoir',
        apiKeyName: 'RESERVOIR_CHART_API',
        method: 'post',
        titleField: 'PrevMonYear.latestStorage',
        keyField: 'objectKey',
        //   urlString: 'KWRIS_API',
        postData: {
          component: 'reservoir',
          chartType: 'stock',
          pEUUID: ProjConstants.STATETOUUIDMAPPING['ANDHRA PRADESH'],
          format: 'yyyyMMdd'
        },
        postDataFormatter: {
          // functionName: 'kwrisFormatter',
          // formatter: (data) => {
          //   console.log('data in the Kwris Formatter', data);
          //   return data;
          // }
        }
      }
    },

    liveStorage3: {
      id: 'liveStorage3',
      title: 'Live Storage(10 Year)',
      chartType: 'line',
      additionalPostParams: 'all',
      unit: 'MCM',
      rendererConfig: {
        chartType: 'line',
        chartColor: '#FBC02D',
        renderer: 'primary',
        visible: true,
        onLoadVisible: false
      },
      apiConfig: {
        apiId: 'reservoir',
        apiKeyName: 'RESERVOIR_CHART_API',
        method: 'post',
        titleField: 'NYearAvg.latestStorage',
        keyField: 'objectKey',
        //   urlString: 'KWRIS_API',
        postData: {
          component: 'reservoir',
          chartType: 'stock',
          pEUUID: ProjConstants.STATETOUUIDMAPPING['ANDHRA PRADESH'],
          format: 'yyyyMMdd'
        },
        postDataFormatter: {
          // functionName: 'kwrisFormatter',
          // formatter: (data) => {
          //   console.log('data in the Kwris Formatter', data);
          //   return data;
          // }
        }
      }
    },

    liveStorageTotal: {
      id: 'liveStorageTotal',
      title: 'Total Storage',
      chartType: 'line',
      additionalPostParams: 'all',
      unit: 'MCM',
      rendererConfig: {
        chartType: 'line',
        chartColor: '#e53935',
        renderer: 'primary',
        visible: true,
      },
      apiConfig: {
        apiId: 'reservoir',
        apiKeyName: 'RESERVOIR_CHART_API',
        method: 'post',
        titleField: 'cap',
        keyField: 'objectKey',
        //   urlString: 'KWRIS_API',
        postData: {
          component: 'reservoir',
          chartType: 'stock',
          pEUUID: ProjConstants.STATETOUUIDMAPPING['ANDHRA PRADESH'],
          format: 'yyyyMMdd'
        },
        postDataFormatter: {
          // functionName: 'kwrisFormatter',
          // formatter: (data) => {
          //   console.log('data in the Kwris Formatter', data);
          //   return data;
          // }
        }
      }
    },



  },
  applicationAdditionalParams: {
    // filter: {
    //   timeInterval: 'format',
    // },
    // date: {
    //     startDate: 'startDateText',
    //     endDate: 'endDateText',
    // },
    // componentSubscription: {
    //     sample : 'sample'
    // }
  },
  routerConfig: {
    routeChangeInvoke: false,
    paramMap: {
      pType: 'lType',
      locUUID: 'lUUID',
      src: 'src',
      sDate: 'sDate',
      eDate: 'eDate',
      view: 'view'
    }
    // paramMap: {
    //     id : 'waterId'
    // }
  },


};

export const ReservoirGIS: StockChartConfig = {
  chartId: 'ReservoirGIS',
  kickStartRequired: [],
  chartOptions: {
    navigator: true,
    indicators: false,
    secondaryChart: false,
    labels: false,
    connectNulls: true,
    hideDataGaps: true,
    rangeSelector: false,
    scrollbar: false,
    yAxis: {
      labelsAlignment: 'left',
      unitAsTitle: false,
      unitsBesideLabel: false,
      labelsFormatter: {
        functionName: 'formatNumber',
      }
    }
  },
  filterConfig: [
    // {
    //   type: 'dropdown',
    //   config: {
    //     title: 'Time Interval',
    //     key: 'timeInterval',
    //     type: 'manual',
    //     icon: 'assets/stockChart/interval.svg',
    //     byDefaultSelect: 'yyyyMMdd',
    //     options: [
    //       {
    //         title: '1 Day',
    //         key: 'yyyyMMdd',
    //       },
    //       {
    //         title: '1 Month',
    //         key: 'yyyyMM',
    //       },
    //       {
    //         title: '1 Year',
    //         key: 'yyyy'
    //       },
    //     ]
    //   },
    //   changeFireEventType: 'api',
    //   functionsFireOnChange: 'all'
    // }
  ],
  applicationConfig: {



    liveStorage: {
      id: 'liveStorage',
      title: 'Live Storage',
      chartType: 'column',
      additionalPostParams: 'all',
      unit: 'MCM',
      rendererConfig: {
        chartType: 'column',
        chartColor: '#3e9cee',
        renderer: 'primary',
        visible: true,
      },
      apiConfig: {
        apiId: 'reservoir',
        apiKeyName: 'RESERVOIR_CHART_API',
        method: 'post',
        titleField: 'currentYearStorage',
        keyField: 'objectKey',
        //   urlString: 'KWRIS_API',
        postData: {
          component: 'reservoir',
          chartType: 'gisChart',
          pEUUID: ProjConstants.STATETOUUIDMAPPING['ANDHRA PRADESH'],
        },
        postDataFormatter: {
          // functionName: 'kwrisFormatter',
          // formatter: (data) => {
          //   console.log('data in the Kwris Formatter', data);
          //   return data;
          // }
        }
      }
    },

    liveStorage2: {
      id: 'liveStorage2',
      title: 'Last Year Live Storage',
      chartType: 'column',
      additionalPostParams: 'all',
      unit: 'MCM',
      rendererConfig: {
        chartType: 'column',
        chartColor: '#FF7043',
        renderer: 'primary',
        visible: true,
        onLoadVisible: false
      },
      apiConfig: {
        apiId: 'reservoir',
        apiKeyName: 'RESERVOIR_CHART_API',
        method: 'post',
        titleField: 'lastYearStorage',
        keyField: 'objectKey',
        //   urlString: 'KWRIS_API',
        postData: {
          component: 'reservoir',
          chartType: 'gisChart',
          pEUUID: ProjConstants.STATETOUUIDMAPPING['ANDHRA PRADESH'],
          format: 'yyyyMMdd'
        },
        postDataFormatter: {
          // functionName: 'kwrisFormatter',
          // formatter: (data) => {
          //   console.log('data in the Kwris Formatter', data);
          //   return data;
          // }
        }
      }
    },

    liveStorage3: {
      id: 'liveStorage3',
      title: 'Live Storage(10 Year)',
      chartType: 'column',
      additionalPostParams: 'all',
      unit: 'MCM',
      rendererConfig: {
        chartType: 'column',
        chartColor: '#FBC02D',
        renderer: 'primary',
        visible: true,
        onLoadVisible: false
      },
      apiConfig: {
        apiId: 'reservoir',
        apiKeyName: 'RESERVOIR_CHART_API',
        method: 'post',
        titleField: 'last10YearStorage',
        keyField: 'objectKey',
        //   urlString: 'KWRIS_API',
        postData: {
          component: 'reservoir',
          chartType: 'gisChart',
          pEUUID: ProjConstants.STATETOUUIDMAPPING['ANDHRA PRADESH'],
          format: 'yyyyMMdd'
        },
        postDataFormatter: {
          // functionName: 'kwrisFormatter',
          // formatter: (data) => {
          //   console.log('data in the Kwris Formatter', data);
          //   return data;
          // }
        }
      }
    },




  },
  applicationAdditionalParams: {
    // filter: {
    //   timeInterval: 'format',
    // },
    // date: {
    //     startDate: 'startDateText',
    //     endDate: 'endDateText',
    // },
    // componentSubscription: {
    //     sample : 'sample'
    // }
  },
  routerConfig: {
    routeChangeInvoke: true,

    paramMap: {
      loctype: 'lType',
      locuuid: 'lUUID',
      src: 'src',
      sDate: 'sDate',
      eDate: 'eDate',
      format: 'format',
      view: 'view'
    }
    // paramMap: {
    //     id : 'waterId'
    // }
  },


};

// export const TemperatureMISNEW: StockChartConfig = {
//   chartId: 'TemperatureMISNEW',
//   kickStartRequired: ['filter'],
//   chartOptions: {
//     navigator: true,
//     indicators: false,
//     secondaryChart: false,
//     labels: false,
//     connectNulls: true,
//     hideDataGaps: true,
//     rangeSelector: false,
//     scrollbar: false,
//     yAxis: {
//       labelsAlignment: 'left',
//       unitAsTitle: false,
//       unitsBesideLabel: false,
//       labelsFormatter: {
//         functionName: 'formatNumber',
//       }
//     }
//   },
//   filterConfig: [
//     {
//       type: 'dropdown',
//       config: {
//         title: 'Time Interval',
//         key: 'timeInterval',
//         type: 'manual',
//         icon: 'assets/stockChart/interval.svg',
//         byDefaultSelect: 'yyyyMMdd',
//         options: [
//           {
//             title: '1 Day',
//             key: 'yyyyMMdd',
//           },
//           {
//             title: '1 Month',
//             key: 'yyyyMM',
//           },
//           // {
//           //   title: '1 Year',
//           //   key: 'yyyy'
//           // },
//         ]
//       },
//       changeFireEventType: 'api',
//       functionsFireOnChange: 'all'
//     }
//   ],


//   applicationConfig: {
//     temperature: {
//       id: 'temperature',
//       title: 'Temperature',
//       chartType: 'spline',
//       additionalPostParams: 'all',
//       unit: '&#8451',
//       apiConfig: {
//         apiCompareConfig: {
//           compareKey: 'NMAX',
//           compareType: ['greater'],
//           greaterColor: '#FF6C40'
//         },
//         candleStickConfig: {
//           highField: 'MAX',
//           lowField: 'MIN',
//           openField: 'MAX',
//           closeField: 'MIN',
//         },
//         areaRangeConfig: {
//           areaMin: 'NMIN',
//           areaMax: 'NMAX'
//         },
//         apiId: 'temperature',
//         apiKeyName: 'TEMPERATURE_CHART_API',
//         method: 'post',
//         titleField: 'MAX',
//         keyField: 'objectKey',
//       //   urlString: 'KWRIS_API',
//         postData: {
//             component: "temperature",
//             pEUUID:ProjConstants.STATETOUUIDMAPPING['ANDHRA PRADESH']
//         },
//         postDataFormatter: {
//           functionName: 'kwrisFormatter',
//           formatter: (data) => {
//             console.log('data in the Kwris Formatter', data);
//             return data;
//           }
//         }
//       },
//       rendererConfig: {
//         renderer: 'primary',
//         visible: true,
//         chartType: ['candlestick', 'areasplinerange'],
//         chartColor: ['#2D99FF', '#FF8F6D']
//         // 2CD9C5
//       },
//       serviceConfig: {
//         unit: {
//           functionName: 'formatUnits',
//           additionalServiceParams: 'all'
//         }
//       }
//     }
//   },

//   applicationAdditionalParams: {
//     filter: {
//       timeInterval: 'format',
//     },
//     // date: {
//     //     startDate: 'startDateText',
//     //     endDate: 'endDateText',
//     // },
//     // componentSubscription: {
//     //     sample : 'sample'
//     // }
//   },
//   routerConfig: {
//     routeChangeInvoke: false,
//     paramMap:{
//           pType:'lType',
//           locUUID:'pUUID',
//           src: 'src',
//           startDateForWaterYear: "sDate",
//           sDate:"eDate",
//           cType:'cType'
//     }
//     // paramMap: {
//     //     id : 'waterId'
//     // }
//   },
// }

export const RiverPointGIS: StockChartConfig = {
  chartId: 'RiverPointGIS',
  kickStartRequired: [],
  chartOptions: {
    navigator: true,
    indicators: false,
    secondaryChart: false,
    labels: false,
    connectNulls: true,
    hideDataGaps: true,
    rangeSelector: false,
    scrollbar: false,
    yAxis: {
      // labelsAlignment: 'left',
      unitAsTitle: true,
      unitsBesideLabel: false,
      labelsFormatter: {
        functionName: 'formatNumber',
      }
    }
  },
  filterConfig: [
    // {
    //   type: 'dropdown',
    //   config: {
    //     title: 'Time Interval',
    //     key: 'timeInterval',
    //     type: 'manual',
    //     icon: 'assets/stockChart/interval.svg',
    //     byDefaultSelect: 'yyyyMMdd',
    //     options: [
    //       {
    //         title: '1 Day',
    //         key: 'yyyyMMdd',
    //       },
    //       {
    //         title: '1 Month',
    //         key: 'yyyyMM',
    //       },
    //       {
    //         title: '1 Year',
    //         key: 'yyyy'
    //       },
    //     ]
    //   },
    //   changeFireEventType: 'api',
    //   functionsFireOnChange: 'all'
    // }
  ],
  applicationConfig: {

    currentYear: {
      id: 'currentYear',
      title: 'Current Year (Discharge in cumecs)',
      chartType: 'column',
      additionalPostParams: 'all',
      unit: 'cumecs',
      rendererConfig: {
        chartType: 'column',
        chartColor: '#0099ff',
        renderer: 'primary',
        visible: true,
      },
      apiConfig: {
        apiId: 'riverpoint',
        apiKeyName: 'RIVERPOINT_CHART_API',
        method: 'post',
        titleField: 'current.flow',
        keyField: 'objectKey',
        //   urlString: 'KWRIS_API',
        postData: {
          sUUID: ProjConstants.STATETOUUIDMAPPING['ANDHRA PRADESH']
        },
        postDataFormatter: {
          functionName: 'riverpointFormatter',
          formatter: (data) => {
            console.log('data in the River Point Formatter', data);
            return data;
          }
        }
      }
    },

    lastYear: {
      id: 'lastYear',
      title: 'Last Year (Discharge in cumecs)',
      chartType: 'column',
      additionalPostParams: 'all',
      unit: 'cumecs',
      rendererConfig: {
        chartType: 'column',
        chartColor: '#90ed7d',
        renderer: 'primary',
        visible: true,
        onLoadVisible: false
      },
      apiConfig: {
        apiId: 'riverpoint',
        apiKeyName: 'RIVERPOINT_CHART_API',
        method: 'post',
        titleField: 'lastYear.flow',
        keyField: 'objectKey',
        //   urlString: 'KWRIS_API',
        postData: {
          sUUID: ProjConstants.STATETOUUIDMAPPING['ANDHRA PRADESH']
        },
        postDataFormatter: {
          functionName: 'riverpointFormatter',
          formatter: (data) => {
            console.log('data in the River Point Formatter', data);
            return data;
          }
        }
      }
    },

    last10Year: {
      id: 'last10Year',
      title: 'Last 10 Year Average (Discharge in cumecs)',
      chartType: 'column',
      additionalPostParams: 'all',
      unit: 'cumecs',
      rendererConfig: {
        chartType: 'column',
        chartColor: '#e9e910',
        renderer: 'primary',
        visible: true,
        onLoadVisible: false
      },
      apiConfig: {
        apiId: 'riverpoint',
        apiKeyName: 'RIVERPOINT_CHART_API',
        method: 'post',
        titleField: 'last10Year.flow',
        keyField: 'objectKey',
        //   urlString: 'KWRIS_API',
        postData: {
          sUUID: ProjConstants.STATETOUUIDMAPPING['ANDHRA PRADESH']
        },
        postDataFormatter: {
          functionName: 'riverpointFormatter',
          formatter: (data) => {
            console.log('data in the River Point Formatter', data);
            return data;
          }
        }
      }
    },

    level: {
      id: 'level',
      title: 'Level (m)',
      chartType: 'spline',
      additionalPostParams: 'all',
      unit: 'meter (m)',
      rendererConfig: {
        chartType: 'spline',
        chartColor: '#e80d0d',
        renderer: 'primary',
        visible: true
      },
      apiConfig: {
        apiId: 'riverpoint',
        apiKeyName: 'RIVERPOINT_CHART_API',
        method: 'post',
        titleField: 'current.level',
        keyField: 'objectKey',
        //   urlString: 'KWRIS_API',
        postData: {
          sUUID: ProjConstants.STATETOUUIDMAPPING['ANDHRA PRADESH']
        },
        postDataFormatter: {
          functionName: 'riverpointFormatter',
          formatter: (data) => {
            console.log('data in the River Point Formatter', data);
            return data;
          }
        }
      }
    }
  },
  applicationAdditionalParams: {
    // filter: {
    //   timeInterval: 'format',
    // },
    // date: {
    //     startDate: 'startDateText',
    //     endDate: 'endDateText',
    // },
    // componentSubscription: {
    //     sample : 'sample'
    // }
  },
  routerConfig: {
    routeChangeInvoke: false,

    paramMap: {
      loctype: 'lType',
      locuuid: 'pUUID',
      cType: 'cType',
      src: 'src',
      sDate: 'sDate',
      eDate: 'eDate',
      format: 'format',
      telementryfilter: 'sType',
      riverid: 'rList'
    }
  },
};

export const GroundWaterMIS: StockChartConfig = {
  chartId: 'GroundWaterMIS',
  kickStartRequired: [],
  chartOptions: {
    navigator: true,
    indicators: false,
    secondaryChart: false,
    labels: false,
    connectNulls: true,
    hideDataGaps: true,
    rangeSelector: false,
    scrollbar: false,
    xAxis: {
      intervalPeriod: 2
    },
    yAxis: {
      // labelsAlignment: 'left',
      unitAsTitle: false,
      unitsBesideLabel: false,
      labelsFormatter: {
        functionName: 'formatNumber',
      }
    }
  },
  filterConfig: [
    // {
    //   type: 'dropdown',
    //   config: {
    //     title: 'Time Interval',
    //     key: 'timeInterval',
    //     type: 'manual',
    //     icon: 'assets/stockChart/interval.svg',
    //     byDefaultSelect: 'yyyyMMdd',
    //     options: [
    //       {
    //         title: '1 Day',
    //         key: 'yyyyMMdd',
    //       },
    //       {
    //         title: '1 Month',
    //         key: 'yyyyMM',
    //       },
    //       {
    //         title: '1 Year',
    //         key: 'yyyy'
    //       },
    //     ]
    //   },
    //   changeFireEventType: 'api',
    //   functionsFireOnChange: 'all'
    // }
  ],
  applicationConfig: {
    GW: {
      id: 'GW',
      title: 'Groundwater Level (m)',
      chartType: 'spline',
      additionalPostParams: 'all',
      unit: 'm',
      unitConversion: true,
      invertAxis: true,
      rendererConfig: {
        chartType: 'spline',
        chartColor: '#FFB900',
        renderer: 'primary',
        visible: true,
        zIndex: 10
      },
      apiConfig: {
        apiId: 'groundwater',
        apiKeyName: 'GROUNDWATER_CHART_API',
        method: 'post',
        titleField: 'GW',
        keyField: 'objectKey',
        //   urlString: 'KWRIS_API',
        postData: {
          pEUUID: ProjConstants.STATETOUUIDMAPPING['ANDHRA PRADESH'],
          src: 'CGWB',
        },
        postDataFormatter: {
          functionName: 'groundwaterFormatter',
          formatter: (data) => {
            console.log('data in Ground-water', data);
            return data;
          }
        }
      }
    },

    RF: {
      id: 'RF',
      title: 'Rainfall (mm)',
      chartType: 'column',
      additionalPostParams: 'all',
      unit: 'mm',
      unitConversion: true,
      apiConfig: {
        apiId: 'groundwater',
        apiKeyName: 'GROUNDWATER_CHART_API',
        //   urlString: 'KWRIS_API',
        apiCompareConfig: {
          lesserColor: '#FF6C40',
          compareKey: 'NRF',
          compareType: ['lesser', 'greater'],
          greaterColor: '#2D99FF',
          // multiplicationFactor:1000
        },
        method: 'post',
        titleField: 'RF',
        keyField: 'objectKey',
        postData: {
          pEUUID: ProjConstants.STATETOUUIDMAPPING['ANDHRA PRADESH'],
          src: 'CGWB',
        },
        postDataFormatter: {
          functionName: 'groundwaterFormatter',
          formatter: (data) => {
            console.log('data in the groundwater Formatter', data);
            return data;
          }
        }
      },

      rendererConfig: {
        chartType: 'column',
        chartColor: '#2D99FF',
        renderer: 'primary',
        visible: true
      }
    },

    NRF: {
      id: 'RF',
      title: 'Normal Rainfall (mm)',
      chartType: 'column',
      additionalPostParams: 'all',
      unit: 'mm',
      unitConversion: true,
      apiConfig: {
        apiId: 'groundwater',
        apiKeyName: 'GROUNDWATER_CHART_API',
        //   urlString: 'KWRIS_API',
        // apiCompareConfig: {
        //   lesserColor: '#FF6C40',
        //   compareKey: 'GW',
        //   compareType: ['lesser', 'greater'],
        //   greaterColor: '#2D99FF',
        //   multiplicationFactor:1000
        // },
        method: 'post',
        titleField: 'NRF',
        keyField: 'objectKey',
        postData: {
          pEUUID: ProjConstants.STATETOUUIDMAPPING['ANDHRA PRADESH'],
          src: 'CGWB',
        },
        postDataFormatter: {
          functionName: 'groundwaterFormatter',
          formatter: (data) => {
            console.log('data in the groundwater Formatter', data);
            return data;
          }
        }
      },

      rendererConfig: {
        chartType: 'column',
        chartColor: '#2D99FF',
        renderer: 'primary',
        visible: false
      }
    },
  },
  applicationAdditionalParams: {
    filter: {
      timeInterval: 'format',
    },
    // date: {
    //     startDate: 'startDateText',
    //     endDate: 'endDateText',
    // },
    // componentSubscription: {
    //     sample : 'sample'
    // }
  },
  routerConfig: {
    routeChangeInvoke: false,
    paramMap: {
      // pUUID : 'locUUID',
      // lType : 'pType',
      // format : 'season',
      // sDate : 'cumEndYear',
      // eDate : 'cumEndYear',



      locUUID: 'pUUID',
      pType: 'lType',
      season: 'format',
      cumEndYear: 'sDate',

      // pType: 'lType',
      // locUUID: 'lUUID',
      // src: 'src',
      // sDate: 'sDate',
      // eDate: 'eDate',
      // view:'view'
    }
    // paramMap: {
    //     id : 'waterId'
    // }
  },
};

export const GROUNDWATERGIS: StockChartConfig = {
  chartId: 'GROUNDWATERGIS',
  kickStartRequired: [],
  chartOptions: {
    navigator: true,
    indicators: false,
    secondaryChart: false,
    labels: false,
    connectNulls: true,
    hideDataGaps: true,
    rangeSelector: false,
    scrollbar: false,
    xAxis: {
      intervalPeriod: 2
    },
    yAxis: {
      // labelsAlignment: 'left',
      unitAsTitle: false,
      unitsBesideLabel: false,
      labelsFormatter: {
        functionName: 'formatNumber',
      }
    }
  },
  filterConfig: [
    // {
    //   type: 'dropdown',
    //   config: {
    //     title: 'Time Interval',
    //     key: 'timeInterval',
    //     type: 'manual',
    //     icon: 'assets/stockChart/interval.svg',
    //     byDefaultSelect: 'yyyyMMdd',
    //     options: [
    //       {
    //         title: '1 Day',
    //         key: 'yyyyMMdd',
    //       },
    //       {
    //         title: '1 Month',
    //         key: 'yyyyMM',
    //       },
    //       {
    //         title: '1 Year',
    //         key: 'yyyy'
    //       },
    //     ]
    //   },
    //   changeFireEventType: 'api',
    //   functionsFireOnChange: 'all'
    // }
  ],
  applicationConfig: {
    GW: {
      id: 'GW',
      title: 'Groundwater Level (m)',
      chartType: 'spline',
      additionalPostParams: 'all',
      unit: 'm',
      unitConversion: true,
      invertAxis: true,
      apiConfig: {
        apiId: 'groundwater',
        apiKeyName: 'GROUNDWATER_CHART_API',
        //   urlString: 'KWRIS_API',
        // apiCompareConfig: {
        //   lesserColor: '#FF6C40',
        //   compareKey: 'normal',
        //   compareType: ['lesser', 'greater'],
        //   greaterColor: '#2D99FF'
        // },
        method: 'post',
        titleField: 'GW',
        keyField: 'objectKey',
        postData: {
          pEUUID: ProjConstants.STATETOUUIDMAPPING['ANDHRA PRADESH'],
          src: 'CGWB',
        },
        postDataFormatter: {
          functionName: 'groundwaterFormatter',
          formatter: (data) => {
            console.log('data in Ground-water', data);
            return data;
          }
        }
      },
      rendererConfig: {
        chartType: 'spline',
        chartColor: '#FFB900',
        renderer: 'primary',
        visible: true,
        zIndex: 10
      },
    },
    RF: {
      id: 'RF',
      title: 'Rainfall (mm)',
      chartType: 'column',
      additionalPostParams: 'all',
      unit: 'mm',
      unitConversion: true,
      rendererConfig: {
        chartType: 'column',
        chartColor: '#2D99FF',
        renderer: 'primary',
        visible: true
      },
      apiConfig: {
        apiId: 'groundwater',
        apiKeyName: 'GROUNDWATER_CHART_API',
        //   urlString: 'KWRIS_API',
        apiCompareConfig: {
          lesserColor: '#FF6C40',
          compareKey: 'NRF',
          compareType: ['lesser', 'greater'],
          greaterColor: '#2D99FF',
          // multiplicationFactor:1000
        },
        method: 'post',
        titleField: 'RF',
        keyField: 'objectKey',
        postData: {
          pEUUID: ProjConstants.STATETOUUIDMAPPING['ANDHRA PRADESH'],
          src: 'CGWB',
        },
        postDataFormatter: {
          functionName: 'groundwaterFormatter',
          formatter: (data) => {
            console.log('data in the groundwater Formatter', data);
            return data;
          }
        }
      }
    },
    NRF: {
      id: 'RF',
      title: 'Normal Rainfall (mm)',
      chartType: 'column',
      additionalPostParams: 'all',
      unit: 'mm',
      unitConversion: true,
      apiConfig: {
        apiId: 'groundwater',
        apiKeyName: 'GROUNDWATER_CHART_API',
        //   urlString: 'KWRIS_API',
        method: 'post',
        titleField: 'NRF',
        keyField: 'objectKey',
        postData: {
          pEUUID: ProjConstants.STATETOUUIDMAPPING['ANDHRA PRADESH'],
          src: 'CGWB',
        },
        postDataFormatter: {
          functionName: 'groundwaterFormatter',
          formatter: (data) => {
            console.log('data in the groundwater Formatter', data);
            return data;
          }
        }
      },

      rendererConfig: {
        chartType: 'column',
        chartColor: '#2D99FF',
        renderer: 'primary',
        visible: false
      }
    },
  },

  applicationAdditionalParams: {
    // filter: {
    //   timeInterval: 'format',
    // },
    // date: {
    //     startDate: 'startDateText',
    //     endDate: 'endDateText',
    // },
    // componentSubscription: {
    //     sample : 'sample'
    // }
  },
  routerConfig: {
    routeChangeInvoke: false,
    paramMap: {
      locuuid: 'pUUID',
      loctype: 'lType',
      seasonType: 'format',
      seasonYear: 'sDate',
    }
  }
}

